/*
 * @Author: Teemo Ding
 * @Date: 2021-04-15 11:55:23
 * @LastEditTime: 2023-03-27 17:01:56
 * @LastEditors: Json Chen
 * @Description: In User Settings Edit
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductAlias/EditPage/ContentDetails/index.tsx
 */

import React from 'react';

import { Input, TextArea } from '@/src/components/Antd';
import CountWords from '@/src/components/CountWords/CountWords';
import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';

import { validateContentDetails } from '../tools';

import { useDispatch } from 'react-redux';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';

import { useI18n } from 'src/hooks/useRouterChange';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';
import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getContentDetails,
  onCollapseOpen,
  onContentDetailsOnChange,
  onErrorChange,
} from '../slice';
const ContentDetails = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data, display, specificError, isOnPrimaryLanguage, disabled } = props;
  const { nameError = [] } = specificError || {};
  const _d = useDispatch();
  const {
    sku,
    productCode,
    productName,
    productSubtitle,
    productDescription,
    productRemarks,
  } = data;

  const handleOnProductName = (value) => {
    _d(onContentDetailsOnChange({ data: { productName: value } }));
  };
  const handleOnDescriptionChange = (value) => {
    _d(onContentDetailsOnChange({ data: { productDescription: value } }));
  };

  const handleOnSubtitleChange = (value) => {
    _d(onContentDetailsOnChange({ data: { productSubtitle: value } }));
  };

  const handleOnRemarksChange = (value) => {
    _d(onContentDetailsOnChange({ data: { productRemarks: value } }));
  };
  const handleOnProductCode = (value) => {
    _d(onContentDetailsOnChange({ data: { productCode: value } }));
  };

  return (
    <Section bottomBorder>
      {isOnPrimaryLanguage && (
        <ItemWrapper title={getI18n('general.sKU')}>
          <div>{sku}</div>
        </ItemWrapper>
      )}
      {isOnPrimaryLanguage && (
        <ItemWrapper
          rightPart={
            <CountWords count={(productCode || '').length} allCount={50} />
          }
          title={getI18n('salesChannelProductAlias.editPage.productCode')}>
          {/* <div>{productCode}</div> */}
          <Input
            size='large'
            value={productCode}
            onChange={handleOnProductCode}
            maxLength={50}
            disabled={disabled}
          />
        </ItemWrapper>
      )}
      <ItemWrapper
        rightPart={
          <CountWords count={(productName || '').length} allCount={50} />
        }
        title={`${getI18n('general.productName')}*`}>
        <Input
          size='large'
          value={productName}
          error={display && (nameError || []).length > 0}
          help={(nameError || []).join(' ')}
          onChange={handleOnProductName}
          maxLength={50}
          disabled={disabled}
        />
      </ItemWrapper>
      <ItemWrapper
        rightPart={
          <CountWords count={(productSubtitle || '').length} allCount={80} />
        }
        title={getI18n('salesChannelProductAlias.editPage.subtitle')}>
        <Input
          size='large'
          value={productSubtitle}
          onChange={handleOnSubtitleChange}
          maxLength={80}
          disabled={disabled}
        />
      </ItemWrapper>
      {isOnPrimaryLanguage && (
        <ItemWrapper
          rightPart={
            <CountWords
              count={(productDescription || '').length}
              allCount={3000}
            />
          }
          title={getI18n('general.upload.EditModal.description')}>
          <TextArea
            value={productDescription}
            onChange={handleOnDescriptionChange}
            maxLength={3000}
            autoSize={{ minRows: 3, maxRows: 999 }}
            disabled={disabled}
          />
        </ItemWrapper>
      )}
      {isOnPrimaryLanguage && (
        <ItemWrapper
          rightPart={
            <CountWords count={(productSubtitle || '').length} allCount={500} />
          }
          title={getI18n('general.remarks')}
          subtitle={getI18n(
            'salesChannelProductAlias.editPage.usedasaninternalcomment,helptofilter',
          )}>
          <TextArea
            value={productRemarks}
            onChange={handleOnRemarksChange}
            maxLength={500}
            autoSize={{ minRows: 1, maxRows: 10 }}
            disabled={disabled}
          />
        </ItemWrapper>
      )}
    </Section>
  );
};

export default ErrorProcessingHOC(ContentDetails, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.contentDetails,
  getContent: getContentDetails,
  title: getI18nFromGeneral('general.hOCTitle.contentDetails'),
  validation: validateContentDetails,
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
});
